//hide show autoplay setup modal
export const showAutoplaySetupModal = () => ({ type: 'SHOW_AUTOPLAY_SETUP_MODAL'})
export const hideAutoplaySetupModal = () => ({ type: 'HIDE_AUTOPLAY_SETUP_MODAL'})
